<template>
  <div v-if="user" class="vx-col w-full md:w-1/3">
    <vx-card title="Profil" class="my-5 text-center">
      <div class="con-img mb-6">
        <center>
          <img
            key="onlineImg"
            :src="'/mpp3.png'"
            alt="user-img"
            width="80"
            height="80"
            class="rounded-full shadow-md cursor-pointer block"
          />
        </center>
      </div>
        <strong>{{user.name}}</strong> <br> 
        <small>{{user.agency_name}}</small>
    </vx-card>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
};
</script>